import type { IMovieRatingData, IRateMovieV1Body } from '@repo/sdk';

function resolveOptimisticWatchCount(current: number, update: IRateMovieV1Body): number {
  if (update.watchCount !== undefined) {
    return Math.max(0, Math.floor(update.watchCount));
  }
  if (update.watched === true) {
    return Math.max(1, current);
  }
  if (update.watched === false) {
    return 0;
  }
  return current;
}

export function applyTrackingUpdate(
  data: IMovieRatingData,
  update: IRateMovieV1Body,
): IMovieRatingData {
  const requestedCount = resolveOptimisticWatchCount(data.watchCount, update);
  const requestedRating = update.rating !== undefined ? update.rating : data.rating;
  const ratingForcesWatch =
    update.rating !== undefined && update.rating !== null && requestedCount === 0;
  const watchCount = ratingForcesWatch ? 1 : requestedCount;
  const rating = watchCount === 0 ? null : requestedRating;
  const wantsToWatch = watchCount > 0 ? false : (update.wantsToWatch ?? data.wantsToWatch);
  return { watched: watchCount > 0, watchCount, wantsToWatch, rating };
}
